var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"bd-app"},[_c('v-main',[_c('Header',{key:_vm.$route.fullPath}),_c('div',{staticClass:"bd-app-content"},[_c('router-view')],1),_c('div',{staticClass:"footer-spacer"}),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }